import React, { Component } from "react";
import { Link } from "react-router-dom";
import client from "@culturehq/client";
import { Form, Panel, PasswordField, SubmitButton, Success } from "@culturehq/components";

import { t, Trans } from "app/utils";

import PasswordChecklist, { PasswordValidator } from "components/common/PasswordChecklist";
import ErrorMessage from "components/common/ErrorMessage";

class ResetPassword extends Component {
  state = { error: false, success: false, validator: new PasswordValidator() };

  handlePasswordChange = password => {
    this.setState(({ validator }) => ({
      validator: validator.mutate({ password })
    }));
  };

  handleConfirmationChange = confirmation => {
    this.setState(({ validator }) => ({
      validator: validator.mutate({ confirmation })
    }));
  };

  handleSubmit = async ({ password }) => {
    const { match: { params: { token } } } = this.props;
    this.setState({ error: false, success: false });

    try {
      await client.resetPassword({ password, token });
      this.setState({ success: true });
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { error, success, validator } = this.state;

    return (
      <Panel className="max-width-360">
        <Panel.Body>
          {error && <ErrorMessage error={error} />}
          {success && <Success><Trans>Password Updated</Trans></Success>}

          {!success && (
            <Form onSubmit={this.handleSubmit}>
              <PasswordField name="password" onChange={this.handlePasswordChange} required>
                <Trans>New Password</Trans>
              </PasswordField>
              <PasswordField name="confirmation" onChange={this.handleConfirmationChange} required>
                <Trans>Confirm Password</Trans>
              </PasswordField>
              <PasswordChecklist validator={validator} />
              <SubmitButton fillParent disabled={!validator.isValid()} primary>
                {submitting => t(submitting ? "Updating..." : "Change Password")}
              </SubmitButton>
            </Form>
          )}
        </Panel.Body>
        <Panel.Footer className="text-center">
          <Link className="link" to="/login">
            <Trans>Back To Sign In Page</Trans>
          </Link>
        </Panel.Footer>
      </Panel>
    );
  }
}

export default ResetPassword;
